import React from 'react';
import { useParams } from 'react-router-dom';

import { EditLibraryForm, useGetLibraryQuery } from 'features/classCreation';
import CreateLibraryClasses from './CreateLibraryClasses';
import ErrorLayout from 'components/ErrorLayout';
import Field from 'components/Field';
import GlobalLoader from 'components/GlobalLoader';
import LibraryClassList from './LibraryClassList';
import Loader from 'components/Loader';
import EditableSection from 'components/EditableSection';

export default function EditLibraryPage() {
  const { libraryId } = useParams();
  const { isLoading, isFetching, error, data, refetch } =
    useGetLibraryQuery(libraryId);

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load library"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const library = data?.data;
    return (
      <div>
        <GlobalLoader isVisible={isFetching} />
        <EditableSection
          canEdit
          titleClassName="dark bold"
          title="Library Name"
        >
          {({ isEditing, setIsEditing }) => (
            <EditLibraryForm
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              library={library}
            />
          )}
        </EditableSection>
        <CreateLibraryClasses library={library} />
        <Field label="Library Contents">
          <LibraryClassList classes={library.library_academy_topics} />
        </Field>
      </div>
    );
  } else {
    return null;
  }
}
